import directives from './module';
import {Observer} from '../services/ViewPortSvc';

directives.directive('isOnScreen', (ViewPortSvc: Observer) => {
        return (scope: any, element: HTMLElement, attrs: {isOnScreen: string}) => {
            // observer.staticWindowHeight = attrs.isOnScreen;
            const centred = parseInt(attrs.isOnScreen, 10);
            ViewPortSvc.subscribe(element[0], centred);
            setTimeout(() => ViewPortSvc.checker(), 0);
            scope.unsubscribe = (el: HTMLElement) => ViewPortSvc.unsubscribe(el);
            scope.$on('$destroy', () => scope.unsubscribe(element[0]));
        };
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/isOnScreenDirective.ts